import { CompanyBillingSettings, Configuration } from '@willow/graphql-iso/src/app';

/**
 * @deprecated
 * Use shared-iso getPaymentDueDay
 */
export const isPaymentDateSettingFor25th = (
  configuration: Configuration,
  billSettings: CompanyBillingSettings,
): boolean => {
  const { productType, constructionLoanType } = configuration;
  const { heloc, construction } = billSettings;

  return Boolean(
    (productType === 'heloc' && heloc === 'dueOnTwentyFifth') ||
    (constructionLoanType && construction === 'dueOnTwentyFifth'),
  );
};
